import { Injectable } from '@angular/core';
import { AddAllOrder, NotificationChanged, ResetOrderInEditMode, SetOrderInEditMode, UpdateOneOrder } from '../action/notification.action';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { OrderEditMode } from '../../00_modules/core/models/OrderEditMode';
import { NotificationStateModel } from '../interface/notification.interface';

const initialState: NotificationStateModel = {
    orderInEditMode: {
        orderId: null,
        user: null,
    },
    orderStateChanged: null,
    ordersEditMode: null,
};

@State<NotificationStateModel>({
    name: 'notification',
    defaults: initialState,
})
@Injectable()
export class NotificationState {
    @Selector()
    static getOrderStateChanged(state: NotificationStateModel) {
        return state.orderStateChanged;
    }

    @Selector()
    static getOrders(state: NotificationStateModel) {
        return state.ordersEditMode;
    }

    @Selector()
    static getOrderInEditMode(state: NotificationStateModel) {
        return state.orderInEditMode;
    }

    @Action(SetOrderInEditMode)
    setOrderInEditMode(ctx: StateContext<NotificationStateModel>, action: SetOrderInEditMode) {
        const state = ctx.getState();

        ctx.patchState({
            orderInEditMode: {
                orderId: action.order.orderId,
                user: action.order.user,
            },
        });
    }

    @Action(ResetOrderInEditMode)
    resetOrderInEditMode(ctx: StateContext<NotificationStateModel>) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            orderInEditMode: {
                orderId: null,
                user: null,
            },
        });
    }

    @Action(NotificationChanged)
    notificationChanged(ctx: StateContext<NotificationStateModel>, action: NotificationChanged) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            orderStateChanged: {
                customerId: action.orderStateChanged.customerId,
                branchId: action.orderStateChanged.branchId,
                newState: action.orderStateChanged.newState,
                previousState: action.orderStateChanged.previousState,
            },
        });
    }

    @Action(AddAllOrder)
    addAllOrder(ctx: StateContext<NotificationStateModel>, action: AddAllOrder) {
        const state = ctx.getState();
        const orders = action.orders as OrderEditMode[];

        const newOrders = orders.map(o => Object.assign({}, o));

        ctx.setState({
            ...state,
            ordersEditMode: newOrders,
        });
    }

    @Action(UpdateOneOrder)
    updateOneOrder(ctx: StateContext<NotificationStateModel>, action: UpdateOneOrder) {
        const state = ctx.getState();
        const order = action.order as OrderEditMode;

        const newOrders = state.ordersEditMode?.map(o => {
            if (o.orderId === order.orderId) {
                return Object.assign({}, order);
            } else {
                return o;
            }
        });

        ctx.setState({
            ...state,
            ordersEditMode: newOrders,
        });
    }
}
